import { render, staticRenderFns } from "./UDIrukuChildOld.vue?vue&type=template&id=7f420402&scoped=true"
import script from "./UDIrukuChildOld.vue?vue&type=script&lang=js"
export * from "./UDIrukuChildOld.vue?vue&type=script&lang=js"
import style0 from "./UDIrukuChildOld.vue?vue&type=style&index=0&id=7f420402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f420402",
  null
  
)

export default component.exports